module.exports = __webpack_public_path__ + "images/recovery.0f9251383d2c9282d0b1e56bc74dbdce.png";